
import { usePortfolioState } from './state';
import { useSyncProtection } from './state';
import { useBillingState } from './state';
import { useNavigationState } from './useNavigationState';

export const usePortfolioSettingsState = () => {
  // Use portfolio state hook
  const {
    portfolioId,
    portfolio,
    name,
    initialName,
    formEdited,
    handleInputChange,
    setName,
    setInitialName,
    setFormEdited
  } = usePortfolioState();

  // Use navigation state hook
  const {
    navigate,
    activeTab,
    setActiveTab,
    selectedPortfolio,
    setSelectedPortfolio,
    showUnsavedChangesDialog,
    setShowUnsavedChangesDialog,
    pendingAction,
    setPendingAction,
    executePendingAction
  } = useNavigationState();

  // Use sync protection hook
  const {
    isUpdatePending,
    updateLockRef,
    handleSave: syncHandleSave,
    handleCancel: syncHandleCancel
  } = useSyncProtection(portfolioId || '');

  // Use billing state hook
  const {
    portfolioData,
    paymentMethods,
    discountCodes,
    totalCharge,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    formatCurrency
  } = useBillingState(portfolioId || '');

  // Create wrapper functions for save and cancel that include the necessary state
  const handleSave = (e?: React.MouseEvent<HTMLButtonElement>) => {
    syncHandleSave(e, name, initialName, setInitialName, pendingAction, executePendingAction);
  };

  const handleCancel = () => {
    syncHandleCancel(setName, initialName, setFormEdited, pendingAction, executePendingAction);
  };

  return {
    portfolioId,
    portfolio,
    name,
    formEdited,
    activeTab,
    selectedPortfolio,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    portfolioData,
    paymentMethods,
    discountCodes,
    totalCharge,
    showUnsavedChangesDialog,
    setShowUnsavedChangesDialog,
    pendingAction,
    setPendingAction,
    navigate,
    toast: { }, // Compatibility with existing code
    handleInputChange,
    handleSave,
    handleCancel,
    formatCurrency,
    setActiveTab,
    setSelectedPortfolio,
    executePendingAction
  };
};
